<ng-container *ngIf="formGroup.errors">
  <ng-container *ngFor="let error of (formGroup.errors | keyvalue)">
    <div *ngFor="let message of error.value" class="small alert callout">
      <i class="fa fa-exclamation-triangle"></i> {{ message }}
    </div>
  </ng-container>
</ng-container>
